import { format } from 'date-fns';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { bind } from 'Mri.Web.Common';
import * as React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Collapse } from 'reactstrap';
import { ZendeskLink } from '../Core/ZendeskLink';

export interface ITicketItemProps {
    readonly ticket: Mri.Tickets.Ticket;
}

@observer
export class TicketItem extends React.Component<ITicketItemProps> {
    public render() {
        const ticket = this.props.ticket;
        return (
            <div className="card d-block mb-3">
                <div className="card-body p-1">
                    <div className="container-fluid px-0">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="flex-items-center h-100">
                                    <div className="w-100">
                                        <LinkContainer
                                            className="p-0 btn btn-link"
                                            to={`/displays/${ticket.displaySerialNumber}`}
                                        >
                                            <small>{ticket.displaySerialNumber} &nbsp;</small>
                                        </LinkContainer>
                                        /
                                        <ZendeskLink id={ticket.ticketId} className="btn btn-link p-0">
                                            <div>&nbsp; View Ticket #{ticket.ticketId}</div>
                                        </ZendeskLink>
                                        <div className="d-inline-block d-md-none float-end">
                                            <strong className={this.statusClassName(ticket.status)}>
                                                {ticket.status.toUpperCase()}
                                            </strong>
                                        </div>
                                        <div>{ticket.subject}</div>
                                        <small>Updated: {format(ticket.dateUpdated, 'M/d/yyyy, h:mm a')}</small>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4 text-start text-md-right">
                                <div className="d-inline-block">
                                    <div className="flex-items-center h-100">
                                        <div>
                                            <div className="d-none d-md-block px-3">
                                                <strong className={this.statusClassName(ticket.status)}>
                                                    {ticket.status.toUpperCase()}
                                                </strong>
                                            </div>

                                            <a className="btn btn-link p-0 p-md-2" onClick={this.onToggle}>
                                                {this.collapsed ? 'View' : 'Hide'} Description
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Collapse isOpen={!this.collapsed}>
                                <div className="col-12 pt-2">
                                    <strong>Description:</strong>
                                    <p>{ticket.description}</p>

                                    <strong>Tags: </strong>
                                    <small>{ticket.tags}</small>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    @bind
    private statusClassName(status: string) {
        switch (status) {
            case 'pending':
                return 'badge bg-info';
            case 'open':
                return 'badge bg-danger';
            case 'hold':
                return 'badge bg-warning';
        }
    }

    @bind
    @action
    private onToggle() {
        this.collapsed = !this.collapsed;
    }

    @observable
    private collapsed = true;
}
